export default {
  ECOMMERCE_LIST_REQUEST: 'APP/ECOMMERCE/ECOMMERCE_LIST_REQUEST',
  ECOMMERCE_LIST_SUCCESS: 'APP/ECOMMERCE/ECOMMERCE_LIST_SUCCESS',
  ECOMMERCE_LIST_ERROR: 'APP/ECOMMERCE/ECOMMERCE_LIST_ERROR',
};
